{
  "app": {
    "name": "หลังบ้านร้าน",
    "loading": "กำลังโหลด…",
    "language": "ภาษา",
    "skip_to_content": "ข้ามไปเนื้อหาหลัก"
  },
  "auth": {
    "sign_in_title": "เข้าสู่ระบบ",
    "sign_in_intro": "บัญชีพนักงานสำหรับหลังบ้านของร้าน",
    "email": "อีเมล",
    "password": "รหัสผ่าน",
    "sign_in": "เข้าสู่ระบบ",
    "sign_out": "ออกจากระบบ",
    "signing_in": "กำลังเข้าสู่ระบบ…",
    "not_available": "ยังไม่ได้เชื่อมต่อการเข้าสู่ระบบ บัญชีพนักงานจะมาพร้อมระบบยืนยันตัวตน",
    "invalid": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
    "dev_bypass_hint": "โหมดพัฒนา: ใส่อีเมลและรหัสผ่านอะไรก็เข้าได้",
    "forbidden_title": "คุณไม่มีสิทธิ์เข้าหน้านี้",
    "forbidden_body": "ติดต่อเจ้าของร้านเพื่อขอเพิ่มสิทธิ์ให้บัญชีของคุณ"
  },
  "home": {
    "title": "วันนี้อยากทำอะไร?",
    "add_card": "ลงการ์ด",
    "add_card_hint": "ลงขายการ์ดใบใหม่ภายในประมาณ 2 นาที",
    "view_orders": "ดูออเดอร์",
    "view_orders_hint": "ออเดอร์จากเว็บและหน้าร้านในที่เดียว",
    "ship": "ส่งของ",
    "ship_hint": "แพ็ก ใส่เลขพัสดุ แจ้งลูกค้า",
    "open_pos": "เปิดเครื่องขาย",
    "open_pos_hint": "เริ่มกะบน POS หน้าร้าน",
    "todo_empty": "ตอนนี้ยังไม่มีสิ่งที่ต้องทำ",
    "edit_banner": "แก้แบนเนอร์หน้าแรก",
    "edit_banner_hint": "เปิดหน้าแก้ไขเว็บที่รูปใหญ่ด้านบนของหน้าแรก"
  },
  "nav": {
    "home": "หน้าแรก",
    "orders": "ออเดอร์",
    "products": "สินค้า",
    "inventory": "สต็อก",
    "menu": "เมนู",
    "online_store": "หน้าตาเว็บไซต์",
    "content": "เนื้อหาเว็บไซต์",
    "more": "เมนู",
    "main": "เมนูหลัก",
    "quick": "เมนูลัด",
    "section": "ในหมวดนี้",
    "close_menu": "ปิดเมนู",
    "coming_soon": "เร็วๆ นี้",
    "external": "(เปิดแอปเครื่องขาย)",
    "groups": {
      "home": "หน้าแรก",
      "orders": "ออเดอร์",
      "products": "สินค้า",
      "inventory": "สต็อก",
      "customers": "ลูกค้า",
      "consignment": "ฝากขาย",
      "pos": "เครื่องขาย (POS)",
      "discounts": "โค้ดส่วนลด",
      "content": "เนื้อหาเว็บไซต์",
      "online_store": "ร้านออนไลน์",
      "settings": "ตั้งค่า"
    },
    "items": {
      "home": "หน้าแรก",
      "orders_all": "ออเดอร์ทั้งหมด",
      "orders_bank_transfers": "โอนเงินรอตรวจ",
      "orders_drafts": "ออเดอร์ร่าง",
      "orders_pickups": "รับที่ร้าน",
      "orders_returns": "คืนสินค้า / คืนเงิน",
      "orders_export_evidence": "หลักฐานส่งออก (輸出免税)",
      "orders_documents": "ค้นหาเอกสาร (電帳法)",
      "products_all": "รายการสินค้า",
      "products_catalog": "คลังข้อมูลการ์ด",
      "products_collections": "คอลเลกชัน",
      "products_categories": "หมวดหมู่",
      "products_brands": "แบรนด์",
      "products_attributes": "ข้อมูลเพิ่มเติมของสินค้า",
      "products_import_export": "นำเข้า / ส่งออก",
      "inventory_stock": "สต็อกคงเหลือ",
      "inventory_movements": "ประวัติสต็อก",
      "inventory_receipts": "รับของเข้า",
      "inventory_transfers": "ย้ายของ",
      "inventory_counts": "นับสต็อก",
      "inventory_holds": "การ์ดที่จองไว้",
      "inventory_conflicts": "ขายซ้ำ — ต้องตัดสิน",
      "inventory_live_shows": "ไลฟ์ขายของ",
      "inventory_locations": "สาขาและคลัง",
      "customers_all": "รายชื่อลูกค้า",
      "customers_groups": "กลุ่มและแท็ก",
      "customers_store_credit": "เครดิตร้าน",
      "consignment_consignors": "ผู้ฝากขาย",
      "consignment_items": "การ์ดฝากขาย",
      "consignment_settlements": "ยอดขายรอสรุป",
      "consignment_payouts": "จ่ายเงินผู้ฝาก",
      "consignment_requests": "คำขอฝากขาย",
      "consignment_kobutsu": "古物台帳 (สมุดบัญชีของมือสอง)",
      "pos_open": "เปิดเครื่องขาย",
      "pos_registers": "เครื่องขาย",
      "pos_shifts": "กะและ Z-report",
      "pos_buylist": "รับซื้อ (買取)",
      "pos_cash": "เงินสดเข้า / ออก",
      "discounts": "โค้ดส่วนลด",
      "content_pages": "หน้าเว็บ",
      "content_policies": "กติกาและนโยบายร้าน",
      "content_menus": "เมนูเว็บ",
      "content_media": "รูปและไฟล์",
      "content_announcements": "ประกาศ",
      "content_redirects": "ที่อยู่เว็บเก่า",
      "content_translations": "คำแปล",
      "content_website_texts": "ข้อความบนเว็บ",
      "online_store_themes": "หน้าตาเว็บไซต์",
      "online_store_markets": "ประเทศและสกุลเงิน",
      "online_store_languages": "ภาษาของเว็บไซต์",
      "online_store_seo": "เครื่องมือค้นหา (SEO)",
      "online_store_domains": "ที่อยู่เว็บ (โดเมน)",
      "settings_store": "ข้อมูลร้าน",
      "settings_tax": "ภาษี (消費税)",
      "settings_shipping": "การจัดส่ง",
      "settings_payments": "การชำระเงิน",
      "settings_checkout": "ขั้นตอนสั่งซื้อ",
      "settings_notifications": "การแจ้งเตือน",
      "settings_inventory": "กฎสต็อก",
      "settings_pos": "กฎเครื่องขาย",
      "settings_staff": "พนักงาน",
      "settings_roles": "บทบาทและสิ่งที่ทำได้",
      "settings_api_keys": "การเชื่อมต่อกับแอปอื่น",
      "settings_audit": "ประวัติการแก้ไข",
      "settings_jobs": "งานเบื้องหลังและการสำรองข้อมูล",
      "settings_features": "ฟีเจอร์ที่จะมาภายหลัง",
      "settings_website_refresh": "รีเฟรชเว็บ",
      "settings_channels": "ตลาดออนไลน์ (eBay, Whatnot…)",
      "settings_analytics": "รายงานและสถิติ",
      "help": "ช่วยเหลือ",
      "profile": "บัญชีของฉัน",
      "inbox": "สิ่งที่ต้องทำและแจ้งเตือน"
    },
    "badge_conflicts_other": "ปัญหาที่ต้องตรวจ {{count}} รายการ",
    "badge_requests_other": "คำขอฝากขายใหม่ {{count}} รายการ"
  },
  "header": {
    "search": "ค้นหา",
    "search_hint": "ค้นหาได้ทุกอย่าง (⌘K)",
    "inbox": "สิ่งที่ต้องทำและแจ้งเตือน",
    "inbox_count": "สิ่งที่ต้องทำและแจ้งเตือน: ค้าง {{count}} รายการ",
    "inbox_critical": "ด่วน {{count}}",
    "user_menu": "เมนูบัญชีของฉัน",
    "profile": "บัญชีของฉัน",
    "help": "ช่วยเหลือ",
    "open_menu": "เปิดเมนูทั้งหมด",
    "inbox_new_title": "มีงานใหม่"
  },
  "page": {
    "help": "ความช่วยเหลือของหน้านี้",
    "back": "กลับ"
  },
  "states": {
    "loading": "กำลังโหลด…",
    "error_title": "โหลดไม่สำเร็จ",
    "error_body": "ตรวจการเชื่อมต่อแล้วลองอีกครั้ง",
    "retry": "ลองอีกครั้ง",
    "empty_title": "ยังไม่มีอะไร",
    "building_title": "หน้านี้กำลังมา",
    "building_body": "\"{{title}}\" จะมาในการอัปเดตครั้งถัดไป ส่วนอื่นยังใช้งานได้ตามปกติ",
    "building_action": "กลับหน้าแรก",
    "coming_soon_title": "จะเปิดในเฟสถัดไป",
    "coming_soon_body": "\"{{title}}\" ยังปิดอยู่ เจ้าของร้านจะเปิดเมื่อร้านพร้อม"
  },
  "errors": {
    "not_found_title": "ไม่พบหน้านี้",
    "not_found_body": "หน้านี้ยังไม่มีหรือถูกย้ายแล้ว",
    "back_home": "กลับหน้าแรก",
    "boundary_title": "เกิดข้อผิดพลาดในหน้านี้",
    "boundary_body": "หน้าอื่นยังใช้ได้ปกติ ลองใหม่ หรือกลับหน้าแรก",
    "try_again": "ลองใหม่",
    "reference": "รหัสอ้างอิง: {{id}}",
    "copy_reference": "คัดลอกรหัสอ้างอิง",
    "copied": "คัดลอกแล้ว",
    "problem_how_to_fix": "มีปัญหา — กดเพื่อดูวิธีแก้",
    "how_to_fix": "ทำอย่างไรต่อ"
  },
  "money": {
    "tax_included": "รวมภาษี",
    "tax_excluded": "ไม่รวมภาษี {{amount}}"
  },
  "date": {
    "jst": "JST"
  },
  "rank": {
    "A": "สภาพดีมาก (美品)",
    "B": "รอยเล็กน้อย (軽い傷)",
    "C": "มีรอย (傷あり)",
    "D": "เสียหาย (ダメージ)",
    "damaged": "เสียหายหนัก",
    "scale": "A 美品 · B 軽い傷 · C 傷あり · D ダメージ",
    "badge_label": "Rank {{rank}} — {{label}}",
    "select_label": "สภาพการ์ด (Rank)",
    "select_hint": "เลือกตัวอักษรที่ตรงกับการ์ด ลูกค้าจะเห็นเสมอ",
    "damaged_label": "เสียหายหนัก (หัก ขาด รอยน้ำ)",
    "ebay_preview": "บน eBay จะแสดงเป็น: {{condition}}",
    "ebay_note": "ใช้เฉพาะตอนส่งขึ้น eBay ในอนาคต",
    "ebay": {
      "A": "Near Mint or Better",
      "B": "Lightly Played",
      "C": "Moderately Played",
      "D": "Heavily Played",
      "D_damaged": "Damaged"
    }
  },
  "status": {
    "active": "ขายอยู่",
    "draft": "ร่าง",
    "problem": "มีปัญหา",
    "pending": "รออยู่",
    "archived": "เก็บเข้าคลัง",
    "info": "แจ้งให้ทราบ"
  },
  "toast": {
    "region": "ข้อความ",
    "undo": "ย้อนกลับ",
    "undo_seconds": "ย้อนกลับ ({{seconds}} วิ)",
    "undone": "ย้อนกลับแล้ว",
    "undo_failed": "ย้อนกลับไม่สำเร็จ",
    "dismiss": "ปิดข้อความ",
    "more": "อีก {{count}} ข้อความ"
  },
  "confirm": {
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "what_happens": "สิ่งที่จะเกิดขึ้น",
    "reason_label": "เหตุผล (บันทึกในประวัติ)",
    "reason_placeholder": "เช่น เสียหายในร้าน, นับใหม่",
    "reason_required": "เขียนเหตุผลสั้นๆ"
  },
  "offline": {
    "banner": "ไม่มีอินเทอร์เน็ต — สิ่งที่พิมพ์ไว้ยังอยู่ จะบันทึกเมื่อกลับมาออนไลน์",
    "back_online": "กลับมาออนไลน์แล้ว"
  },
  "forms": {
    "required": "จำเป็น",
    "optional": "ไม่บังคับ",
    "saving": "กำลังบันทึก…",
    "save": "บันทึก",
    "draft_saved_at": "บันทึกร่างแล้ว {{time}}",
    "restore_title": "กู้คืนร่าง?",
    "restore_body": "คุณเริ่มกรอกฟอร์มนี้เมื่อ {{time}} และยังไม่ได้บันทึก",
    "restore": "กู้คืนร่าง",
    "discard": "เริ่มใหม่",
    "leave_title": "ออกโดยไม่บันทึก?",
    "leave_body": "สิ่งที่กรอกในหน้านี้ยังไม่ได้บันทึก ร่างยังเก็บไว้ในเครื่องนี้",
    "leave": "ออกจากหน้านี้",
    "stay": "อยู่หน้านี้ต่อ",
    "conflict_title": "มีคนแก้ข้อมูลนี้ก่อนคุณ",
    "conflict_body": "{{name}} บันทึกฉบับใหม่กว่าแล้ว โหลดใหม่เพื่อดูการเปลี่ยนแปลง หรือเก็บของคุณแล้วเขียนทับ",
    "conflict_someone": "พนักงานคนอื่น",
    "load_latest": "โหลดใหม่",
    "overwrite": "เขียนทับด้วยของฉัน",
    "fix_errors": "กรุณาแก้ {{count}} ช่องที่ขึ้นสีแดง",
    "help": "นี่คืออะไร?",
    "help_more": "อ่านเพิ่ม",
    "select_placeholder": "เลือก…",
    "select_search": "พิมพ์เพื่อค้นหา",
    "select_empty": "ไม่พบ",
    "on": "เปิด",
    "off": "ปิด",
    "yen_hint": "เงินเยนเต็มจำนวน รวมภาษี",
    "date_hint": "เวลาญี่ปุ่น (JST)"
  },
  "table": {
    "rows_per_page": "จำนวนแถวต่อหน้า",
    "next": "ถัดไป",
    "previous": "ก่อนหน้า",
    "page_rows": "แสดง {{count, number}} รายการ",
    "total": "ทั้งหมด {{count, number}} รายการ",
    "filters": "ตัวกรอง",
    "open_filters": "ตัวกรอง ({{count}})",
    "clear_filters": "ล้างทั้งหมด",
    "remove_filter": "เอาตัวกรอง {{name}} ออก",
    "apply": "ดูผลลัพธ์",
    "any": "ทั้งหมด",
    "yes": "ใช่",
    "no": "ไม่",
    "search": "ค้นหา",
    "from": "ตั้งแต่",
    "to": "ถึง",
    "today": "วันนี้",
    "last_7_days": "7 วันล่าสุด",
    "this_month": "เดือนนี้",
    "saved_views": "มุมมองที่บันทึก",
    "all_rows": "ทั้งหมด",
    "save_view": "บันทึกมุมมองนี้",
    "view_name": "ชื่อมุมมอง",
    "rename_view": "เปลี่ยนชื่อ",
    "delete_view": "ลบ",
    "delete_view_title": "ลบมุมมอง \"{{name}}\"?",
    "delete_view_body": "ลบเฉพาะตัวกรองที่บันทึกไว้ ไม่ได้ลบข้อมูล",
    "pin_view": "ปักหมุดไว้บนสุด",
    "unpin_view": "เลิกปักหมุด",
    "view_saved": "บันทึกมุมมอง \"{{name}}\" แล้ว",
    "view_deleted": "ลบมุมมองแล้ว",
    "columns": "คอลัมน์ที่แสดง",
    "show_column": "แสดง {{name}}",
    "move_up": "เลื่อน {{name}} ขึ้น",
    "move_down": "เลื่อน {{name}} ลง",
    "pin_left": "ปัก {{name}} ไว้ซ้าย",
    "density": "ความสูงแถว",
    "density_comfortable": "สบายตา",
    "density_compact": "กระชับ",
    "export_csv": "ดาวน์โหลด CSV",
    "exporting": "กำลังเตรียมไฟล์…",
    "exported": "ดาวน์โหลด CSV แล้ว",
    "selected_count": "เลือก {{count, number}} รายการ",
    "clear_selection": "ล้างที่เลือก",
    "select_all": "เลือกทั้งหน้า",
    "select_row": "เลือกแถว",
    "sort_by": "เรียงตาม {{name}}",
    "loading": "กำลังโหลด…",
    "empty": "ไม่มีรายการที่ตรง ลองเปลี่ยนตัวกรอง",
    "error": "โหลดรายการไม่สำเร็จ",
    "actions": "การทำงาน",
    "yen_column": "{{name}} (เยน)",
    "load_more": "แสดงเพิ่ม"
  },
  "roles": {
    "owner": "เจ้าของร้าน",
    "manager": "ผู้จัดการ",
    "staff": "พนักงานร้าน",
    "cashier": "แคชเชียร์",
    "content_editor": "ผู้แก้ไขเว็บ",
    "consignment_manager": "ผู้ดูแลฝากขาย"
  },
  "permissions": {
    "needs_owner": "เฉพาะเจ้าของร้านทำได้",
    "needs_manager": "ต้องเป็นผู้จัดการ — ให้ผู้จัดการหรือเจ้าของร้านทำ",
    "needs_other": "บัญชีนี้ทำไม่ได้ — ขอสิทธิ์จากเจ้าของร้าน"
  },
  "flags": {
    "when": "เปิดใช้ได้ภายหลัง เมื่อเจ้าของร้านสั่ง",
    "page_intro": "ส่วนนี้ปิดไว้ก่อน หลังบ้านส่วนอื่นใช้งานได้ตามปกติ",
    "payments_stripe": {
      "title": "รับบัตรออนไลน์ (Stripe)",
      "body": "ลูกค้าจ่ายด้วยบัตร Apple Pay หรือ Google Pay บนเว็บ"
    },
    "payments_stripe_connect": {
      "title": "จ่ายผู้ฝากขายผ่าน Stripe",
      "body": "เงินของผู้ฝากขายเข้าบัญชีธนาคารโดยตรงผ่าน Stripe"
    },
    "channels_ebay": {
      "title": "ขายบน eBay",
      "body": "การ์ดขึ้น eBay เอง ขายที่ไหนก็ถอนจากทุกที่"
    },
    "channels_whatnot": {
      "title": "ขายในไลฟ์ Whatnot",
      "body": "นำการ์ดขึ้นประมูลไลฟ์ ที่ขายได้กลับมาเป็นออเดอร์"
    },
    "channels_mercari": {
      "title": "ขายบน Mercari Shops",
      "body": "ลงการ์ดบน Mercari Shops จากสต็อกเดียวกัน"
    },
    "channels_tiktok_shop": {
      "title": "ขายบน TikTok Shop",
      "body": "ลงการ์ดบน TikTok Shop จากสต็อกเดียวกัน"
    },
    "tax_nta_api": {
      "title": "ส่งข้อมูล 免税 ให้กรมสรรพากรอัตโนมัติ",
      "body": "ส่งข้อมูลการขาย 免税 โดยไม่ต้องอัปโหลดไฟล์"
    },
    "shipping_shipandco": {
      "title": "ใบปะหน้าจาก Ship&co",
      "body": "พิมพ์ใบปะหน้าและเลขติดตามในขั้นตอนเดียว"
    },
    "shipping_zonos": {
      "title": "จ่ายภาษีนำเข้าตอนสั่ง (Zonos)",
      "body": "ลูกค้าต่างประเทศจ่ายภาษีนำเข้าตอนสั่งซื้อ"
    }
  },
  "order_status": {
    "pending_payment": "รอชำระเงิน",
    "paid": "ชำระแล้ว",
    "partially_paid": "ชำระบางส่วน",
    "partially_refunded": "คืนเงินบางส่วน",
    "refunded": "คืนเงินแล้ว",
    "cancelled": "ยกเลิก"
  },
  "fulfillment_status": {
    "unfulfilled": "ยังไม่เตรียม",
    "preparing": "กำลังเตรียม",
    "ready": "เตรียมของแล้ว",
    "shipped": "ส่งแล้ว",
    "in_transit": "กำลังขนส่ง",
    "delivered": "ส่งถึงแล้ว",
    "partial": "ส่งบางส่วน",
    "pickup_ready": "พร้อมให้รับที่ร้าน",
    "picked_up": "รับแล้ว",
    "return_requested": "ขอคืนสินค้า",
    "return_received": "รับของคืนแล้ว"
  },
  "sortable": {
    "drag": "ลาก {{name}}",
    "up": "เลื่อน {{name}} ขึ้น",
    "down": "เลื่อน {{name}} ลง",
    "moved": "{{name}} อยู่ลำดับที่ {{to}} จาก {{count}} แล้ว"
  },
  "dialog": {
    "close": "ปิด",
    "cancel": "ยกเลิก"
  },
  "copy": {
    "copy": "คัดลอก",
    "copied": "คัดลอกแล้ว",
    "failed": "เลือกแล้วคัดลอกเอง"
  },
  "live": {
    "menu": "อัปเดตอัตโนมัติ",
    "menu_hint": "หน้านี้อัปเดตเองเมื่อมีการเปลี่ยนแปลง",
    "toasts": "แสดงข้อความเมื่อมีเรื่องใหม่",
    "sound": "เล่นเสียงเบาๆ ด้วย",
    "new_order": "มีออเดอร์ใหม่เข้ามา",
    "transfer_notice": "ลูกค้าแจ้งว่าโอนเงินแล้ว",
    "payment_received": "เงินของออเดอร์เข้าแล้ว",
    "pos_sale": "มีการขายที่หน้าร้าน",
    "oversell": "การ์ดใบเดียวกันขายซ้ำสองที่ กรุณาตรวจสอบทันที",
    "consignment_request": "มีคำขอฝากขายใหม่",
    "see": "ดูในรายการ",
    "new_row": "ใหม่",
    "conflict": "ข้อมูลนี้ถูกแก้โดยผู้อื่นระหว่างที่คุณแก้อยู่",
    "conflict_by": "ข้อมูลนี้ถูกแก้โดย {{name}} ระหว่างที่คุณแก้อยู่",
    "reload": "โหลดล่าสุด"
  },
  "shop_switches": {
    "licence_missing": "ปิดรับซื้อการ์ด (買取) และรับฝากขายไว้ก่อน เพราะยังไม่ได้กรอกเลข 古物商許可 ของร้าน",
    "licence_fix": "ไปกรอกที่ข้อมูลร้าน",
    "web_orders_paused": "ตอนนี้เว็บหยุดรับออเดอร์ชั่วคราว — หน้าร้าน/POS ขายได้ตามปกติ",
    "web_orders_open": "เปิดหน้าตั้งค่าขั้นตอนสั่งซื้อ"
  }
}
